import { createContext, useContext } from "react";
import { getPluginRequest } from '../api/client.js'
import { USERNAME } from "../Config.js";

const ClientContext = createContext()

export const useClients = () => {
    const context = useContext(ClientContext)
    if(!context) throw new Error("useClients must be used within an TaskProvider")

    return context
}

export const ClientProvider = ({children}) => {
    const getPlugin = async () => {
        try {
            const res = await getPluginRequest(USERNAME)
            return res.data.plugin
        } catch(error) {
            console.log(error)
        }
    }

    return(
        <ClientContext.Provider value={{getPlugin}}>
            {children}
        </ClientContext.Provider>
    )
}